import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function Register() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [referralCode, setReferralCode] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const isPasswordMismatch = confirmPassword.length > 0 && password !== confirmPassword;

    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        const prefFillCode = params.get('ref');
        if (prefFillCode) {
            setReferralCode(prefFillCode.toUpperCase());
        }
    }, [location.search]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setLoading(true);
        setIsSuccess(false);

        if (password !== confirmPassword) {
            setMessage('Passwords do not match. Please try again.');
            setIsSuccess(false);
            setLoading(false);
            return;
        }

        try {
            const response = await fetch('/api/auth/signup', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password, referralCode: referralCode.trim() || undefined }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage('Registration successful! Redirecting to login...');
                setIsSuccess(true);
                setEmail('');
                setPassword('');
                setConfirmPassword('');
                setReferralCode('');
                setTimeout(() => {
                    navigate('/login');
                }, 2000); // Redirect after 2 seconds
            } else {
                setMessage(data.msg || (data.errors && data.errors[0].msg) || 'Registration failed.');
                setIsSuccess(false);
            }
        } catch (err) {
            setMessage('Network error or server is unreachable.');
            setIsSuccess(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page auth-page">
            <div className="auth-card">
                <h2>Create your account</h2>
                <p className="text-muted text-center">Grab your apron—getting started only takes a moment.</p>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="emailInput" className="form-label">Email address</label>
                        <input
                            type="email"
                            className="form-control"
                            id="emailInput"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="passwordInput" className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="passwordInput"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="referralCodeInput" className="form-label">Referral code (optional)</label>
                        <input
                            type="text"
                            className="form-control"
                            id="referralCodeInput"
                            value={referralCode}
                            onChange={(e) => setReferralCode(e.target.value.toUpperCase())}
                            placeholder="Enter creator referral code"
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="confirmPasswordInput" className="form-label">Confirm password</label>
                        <input
                            type="password"
                            className={`form-control ${isPasswordMismatch ? 'is-invalid' : ''}`}
                            id="confirmPasswordInput"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                        {isPasswordMismatch && (
                            <div className="invalid-feedback d-block">
                                Passwords must match.
                            </div>
                        )}
                    </div>
                    <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading || isPasswordMismatch}
                    >
                        {loading ? 'Registering...' : 'Register'}
                    </button>
                </form>
                {message && (
                    <div className={`alert mt-3 ${isSuccess ? 'alert-success' : 'alert-danger'} text-center`}>
                        {message}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Register;
